import React from 'react'
import PropTypes from 'prop-types'
import relatedlinkStyles from '../../styles/modules/relatedlink.module.less'
import { pubdateString, moddateString, convertDatesToAP, formatTimestamp } from '../sfc/component-helpers/datehelpers'

const RelatedLink = ({ url, title, pubdate }) => {
	const months = ['Jan.','Feb.','March','April','May','June','July','Aug.','Sept.','Oct.','Nov.','Dec.']
	let formatted_date = new Date(pubdate)
	formatted_date = months[formatted_date.getMonth()] + " " + formatted_date.getDate() + ", " + formatted_date.getFullYear()
	
	return (
    <li className={relatedlinkStyles.item}>
    	<span className={relatedlinkStyles.bullet}></span>
    	<span className={relatedlinkStyles.text}><a href={url}>{title}</a></span>
      <span className={relatedlinkStyles.date}>{formatted_date}</span>
    </li>
	)
}

RelatedLink.propTypes = {
  url: PropTypes.string,
  title: PropTypes.string,
}

export default RelatedLink
